import { Card, OrderLineItem } from 'corso-admin-ui';
import { CrewClaimResolutionMethodEnum } from 'corso-types';
import { Key } from 'react';
import ResolutionMethodBadge from '~/components/ResolutionMethodBadge';

// we really need a universal reusable line item type
type WarrantyReviewLineItem = {
  id: Key;
  name: string | null;
  imgUrl: string | null;
  quantity: number;
  optionsFromPlatform: {
    value: string;
    name: string;
  }[];
  unitPrice: number | null;
  unitTax: number | null;
  sku?: string | null;
};

type WarrantyReview = {
  id: Key;
  lineItems: WarrantyReviewLineItem[];
};

export default function WarrantyReviewLine({
  warrantyReview,
  isRepair = false,
}: {
  warrantyReview: WarrantyReview;
  isRepair?: boolean;
}) {
  return (
    <section className="space-y-2">
      <Card.Line>
        <div>
          <ResolutionMethodBadge
            resolutionMethod={
              isRepair
                ? CrewClaimResolutionMethodEnum.repair
                : CrewClaimResolutionMethodEnum.warrantyReview
            }
            icon
          />
        </div>
      </Card.Line>
      <ul className="space-y-2 py-2">
        {warrantyReview.lineItems.map((lineItem) => (
          <li key={lineItem.id}>
            <OrderLineItem
              size="sm"
              title={lineItem.name}
              src={lineItem.imgUrl}
              quantity={lineItem.quantity}
              options={lineItem.optionsFromPlatform}
              sku={lineItem.sku}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
